import AddType from './add-type';

export default AddType;
